import { router } from '@inertiajs/react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { PaginationMeta } from '@/types'

interface PaginationProps {
  pagination: PaginationMeta
  baseUrl: string
  params?: Record<string, string | null>
}

export default function Pagination({ pagination, baseUrl, params = {} }: PaginationProps) {
  if (pagination.pages <= 1) return null

  function goToPage(page: number) {
    router.get(baseUrl, { ...params, page }, { preserveState: true, preserveScroll: true })
  }

  return (
    <div className="flex items-center justify-between pt-4">
      <p className="text-xs text-muted-foreground">
        Page {pagination.page} of {pagination.pages} ({pagination.count} total)
      </p>
      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="icon-xs"
          disabled={pagination.page <= 1}
          onClick={() => goToPage(pagination.page - 1)}
        >
          <ChevronLeft className="size-3.5" />
        </Button>
        <Button
          variant="outline"
          size="icon-xs"
          disabled={pagination.page >= pagination.pages}
          onClick={() => goToPage(pagination.page + 1)}
        >
          <ChevronRight className="size-3.5" />
        </Button>
      </div>
    </div>
  )
}
